import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { TranslationEditor } from '../translation-editor';
import { TranslateModel } from '../../models/translate-model';

@injectable()
export class TranslationEditorImpl implements TranslationEditor {
    constructor(
        @inject(TranslateModel)
        private _aiTranslationModel: TranslateModel,
    ) {}

    editOriginal(idx: number): () => void {
        this._aiTranslationModel.update(state => {
            return {
                ...state,
                editingOriginalIdx: idx,
                editingTranslationIdx: -1,
            };
        });

        return () => {
            this._aiTranslationModel.update(state => {
                return {
                    ...state,
                    editingOriginalIdx: -1,
                    editingTranslationIdx: -1,
                };
            });
        };
    }

    editTranslation(idx: number): () => void {
        this._aiTranslationModel.update(state => {
            return {
                ...state,
                editingTranslationIdx: idx,
                editingOriginalIdx: -1,
            };
        });

        return () => {
            this._aiTranslationModel.update(state => {
                return {
                    ...state,
                    editingTranslationIdx: -1,
                    editingOriginalIdx: -1,
                };
            });
        };
    }
}
